export default "__VITE_PUBLIC_ASSET__8970e13b__"